import { FC, HTMLAttributes, PropsWithChildren } from 'react'

import { CardHeaderActions } from './card-header-actions'
import { CardHeaderTitle } from './card-header-title'
import { classNames } from '@common/utils/helpers'
import styled from '@emotion/styled'

interface ICardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  className?: string | undefined
}

interface ICardHeader extends FC<PropsWithChildren<ICardHeaderProps>> {
  Title: typeof CardHeaderTitle
  Actions: typeof CardHeaderActions
}

/**
 * @deprecated use {@palqee/ui/card}
 */
const CardHeader: ICardHeader = (props) => {
  const { children, className, ...rest } = props
  const classes = classNames('pq-card__header', className || '')

  return (
    <CardHeaderWrapper className={classes} {...rest}>
      {children}
    </CardHeaderWrapper>
  )
}

const CardHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

CardHeader.Title = CardHeaderTitle
CardHeader.Actions = CardHeaderActions

export { CardHeader }
